export class ContactPropertyApiAppointmentFilters {
  branches: number[] = [];
  types: number[] = [];
  status: number | null = null;
  assignedTo: number[] = [];
}
